const FETCH_PAYMENTS = 'fetch_payments';
const FETCH_PAYMENT = 'fetch_payment';
const DELETE_PAYMENT = 'delete_payment';
const PERSIST_PAYMENT = 'persist_payment';
export default {
    FETCH_PAYMENTS,
    FETCH_PAYMENT,
    DELETE_PAYMENT,
    PERSIST_PAYMENT,
};
